import React, {FunctionComponent, ReactElement} from 'react';
import {_ReactPixi} from '@inlet/react-pixi';
import {UpdateManager} from '@gongxigames/framework/core';
import {SlideView} from '@gongxigames/framework/slot/modules/loadingScreen/components/Slides/SlideView';

export type SlidesPresentationProps = Omit<_ReactPixi.IContainer, 'position' | 'scale'> & {
    slides: ReactElement[];
    activeIndex: number;
    updateManager: UpdateManager;
};

export const SlidesPresentation: FunctionComponent<SlidesPresentationProps> = ({slides, activeIndex, updateManager}) => {
    const elements = slides.map((slide, i) => {
        return <SlideView
            updateManager={updateManager}
            slide={slide}
            key={i}
            visible={i === activeIndex}
        >{slide}</SlideView>;
    });

    return <>{elements}</>;
};
